import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { User } from '../../../model/user.model';
import { UserService } from '../../../service/user.service';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from 'src/app/service/auth.service';
import { MatTableDataSource } from '@angular/material';
import { Reservation } from 'src/app/model/reservation.model';
import { ReservationService } from 'src/app/service/reservation.service';

@Component({
  selector: 'app-profile',
  templateUrl: './user-detail.component.html',
  styleUrls: ['./user-detail.component.css']
})
export class UserDetailComponent implements OnInit {
  user: User;
  isLesson: number;

  constructor(
    private userService: UserService,
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    private router: Router,
    private reservationService: ReservationService) {
      if (this.router.getCurrentNavigation().extras.state) {
        this.isLesson = this.router.getCurrentNavigation().extras.state.isLesson as number;
      }
    }

  ngOnInit() {
    this.user = this.authService.currentUserValue;
  }

  editProfile(user: User) {
    this.router.navigateByUrl('/profile-edit/' + user.id);
  }
}
